interface IconProps {
  color?: string
}

export const Plus = ({ color }: IconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 5.34998C12.3591 5.34998 12.6501 5.64099 12.6501 5.99998V11.35L18.0001 11.35C18.3591 11.35 18.6501 11.641 18.6501 12C18.6501 12.359 18.3591 12.65 18.0001 12.65L12.6501 12.65V18C12.6501 18.359 12.3591 18.65 12.0001 18.65C11.6411 18.65 11.3501 18.359 11.3501 18V12.65L6.0001 12.65C5.64111 12.65 5.3501 12.359 5.3501 12C5.3501 11.641 5.64111 11.35 6.0001 11.35L11.3501 11.35V5.99998C11.3501 5.64099 11.6411 5.34998 12.0001 5.34998Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
